import type { LocText } from "./schema";

export type Lang = "fr" | "en";

let current: Lang = "fr";

export function setLang(l: Lang): void {
  current = l;
}
export function getLang(): Lang {
  return current;
}

/** Resolve a bilingual LocText to the active language. */
export function t(text: LocText | undefined, fallback = ""): string {
  if (!text) return fallback;
  return text[current] ?? text.fr ?? fallback;
}
